module.exports = __webpack_public_path__ + "img/p&s-course2.dd32e037.jpg";